import * as React from 'react';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';
import { 
  RequestApiResult
} from 'loopback-react-request';

export interface TroughQtyProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: any;
  troughId: string;
}

export class TroughQtyPartial extends React.Component<TroughQtyProps> {
  public render() {
    return (
      <div className="partial-trough-qty">
        {this.quantity}
      </div>
    );
  }
  
  private get quantity(): number | null | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.selectedTrough && 
      configuration.result.selectedTrough.qty;
  }
}

export const TroughQty = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(TroughQtyPartial);

export default TroughQty;
